export default __webpack_public_path__ + "dd28d9c5ef863734c662cf57ecc83829.png";